export type WorkspaceStateName =
  | "active"
  | "pending_verification"
  | "verification_rejected"
  | "membership_revoked"
  | "membership_invited"
  | "migration_hold"
  | "no_company"

export type WorkspaceBoundaryMode =
  | "loading"
  | "passthrough"
  | "revoked"
  | "invited"
  | "migration_hold"
  | "no_company"

export function workspaceBoundaryMode(
  state: WorkspaceStateName | undefined,
  pathname: string,
): WorkspaceBoundaryMode {
  if (state === undefined) return "loading"

  const personalAccount = pathname.startsWith("/recruit/settings/account")
  if (
    personalAccount &&
    (state === "membership_revoked" ||
      state === "membership_invited" ||
      state === "migration_hold" ||
      state === "no_company")
  ) {
    return "passthrough"
  }

  if (state === "membership_revoked") return "revoked"
  if (state === "membership_invited") return "invited"
  if (state === "migration_hold") return "migration_hold"
  if (state === "no_company") return "no_company"
  return "passthrough"
}
